var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors())?_c('div',{attrs:{"id":"error-messages"}},[_c('ul',_vm._l((_vm.errors),function(value,key){return _c('li',{key:key},[_c('strong',[_vm._v(_vm._s(key))]),_vm._l((value),function(error,index){return _c('span',{key:index},[_vm._v("\n        "+_vm._s(error)+"\n      ")])})],2)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }